/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Tab_Deepmatch_DescInputs */

const en_landing_tab_deepmatch_desc = /** @type {(inputs: Landing_Tab_Deepmatch_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Our AI doesn't just match keywords — it understands role requirements, maps your skills, and scores true fit. See exactly where you're strong and where to improve.`)
};

const de_landing_tab_deepmatch_desc = /** @type {(inputs: Landing_Tab_Deepmatch_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unsere KI matcht nicht nur Keywords — sie versteht Anforderungen, kartiert deine Skills und bewertet die echte Passung. Sieh genau, wo du stark bist.`)
};

const fr_landing_tab_deepmatch_desc = /** @type {(inputs: Landing_Tab_Deepmatch_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Our AI doesn't just match keywords — it understands role requirements, maps your skills, and scores true fit. See exactly where you're strong and where to improve.`)
};

const es_landing_tab_deepmatch_desc = /** @type {(inputs: Landing_Tab_Deepmatch_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Our AI doesn't just match keywords — it understands role requirements, maps your skills, and scores true fit. See exactly where you're strong and where to improve.`)
};

const it_landing_tab_deepmatch_desc = /** @type {(inputs: Landing_Tab_Deepmatch_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Our AI doesn't just match keywords — it understands role requirements, maps your skills, and scores true fit. See exactly where you're strong and where to improve.`)
};

const nl_landing_tab_deepmatch_desc = /** @type {(inputs: Landing_Tab_Deepmatch_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Our AI doesn't just match keywords — it understands role requirements, maps your skills, and scores true fit. See exactly where you're strong and where to improve.`)
};

const pl_landing_tab_deepmatch_desc = /** @type {(inputs: Landing_Tab_Deepmatch_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Our AI doesn't just match keywords — it understands role requirements, maps your skills, and scores true fit. See exactly where you're strong and where to improve.`)
};

const fi_landing_tab_deepmatch_desc = /** @type {(inputs: Landing_Tab_Deepmatch_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Our AI doesn't just match keywords — it understands role requirements, maps your skills, and scores true fit. See exactly where you're strong and where to improve.`)
};

const da_landing_tab_deepmatch_desc = /** @type {(inputs: Landing_Tab_Deepmatch_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Our AI doesn't just match keywords — it understands role requirements, maps your skills, and scores true fit. See exactly where you're strong and where to improve.`)
};

const sv_landing_tab_deepmatch_desc = /** @type {(inputs: Landing_Tab_Deepmatch_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Our AI doesn't just match keywords — it understands role requirements, maps your skills, and scores true fit. See exactly where you're strong and where to improve.`)
};

/**
* | output |
* | --- |
* | "Our AI doesn't just match keywords — it understands role requirements, maps your skills, and scores true fit. See exactly where you're strong and where to im..." |
*
* @param {Landing_Tab_Deepmatch_DescInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const landing_tab_deepmatch_desc = /** @type {((inputs?: Landing_Tab_Deepmatch_DescInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Tab_Deepmatch_DescInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_landing_tab_deepmatch_desc(inputs)
	if (locale === "fr") return fr_landing_tab_deepmatch_desc(inputs)
	if (locale === "es") return es_landing_tab_deepmatch_desc(inputs)
	if (locale === "it") return it_landing_tab_deepmatch_desc(inputs)
	if (locale === "nl") return nl_landing_tab_deepmatch_desc(inputs)
	if (locale === "pl") return pl_landing_tab_deepmatch_desc(inputs)
	if (locale === "fi") return fi_landing_tab_deepmatch_desc(inputs)
	if (locale === "da") return da_landing_tab_deepmatch_desc(inputs)
	if (locale === "sv") return sv_landing_tab_deepmatch_desc(inputs)
	return en_landing_tab_deepmatch_desc(inputs)
});